/**
 * Site JavaScript
 *
 * Bundled by esbuild to public/assets/js/main.js.
 * Included via <script src="/assets/js/main.js" defer>.
 *
 * Build:  pnpm run build
 * Watch:  pnpm run watch
 */

// The subscribe form is wired by the include the SSG injects at build time
// (forms.api_origin in site.yaml). It owns the nonce, honeypots, Turnstile,
// and the POST, keyed off the subscribe intent attribute in the signup
// partial. Nothing to do here: a second submit handler would post without
// the nonce and be refused.

function ready(fn: () => void) {
  if (document.readyState !== "loading") {
    fn();
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

/**
 * Hire form.
 *
 * There is no inbox behind a POST endpoint yet, so this composes a mailto: from
 * the answers and hands off to the visitor's mail client. Nothing is sent from
 * the page and nothing is stored here. When an endpoint exists, swap the
 * `location.href = mailto` for a fetch and keep the mailto as the fallback.
 */
const HIRE_TO = "contact@ionalpha.io";

function initHire() {
  const form = document.getElementById("hire") as HTMLFormElement | null;
  if (!form) return;

  const statusEl = document.getElementById("hire-status");
  const honeypot = form.querySelector<HTMLInputElement>('input[name="website"]');

  function setStatus(msg: string, kind: "ok" | "err" | "") {
    if (!statusEl) return;
    statusEl.textContent = msg;
    statusEl.className = "signup-status" + (kind ? ` is-${kind}` : "");
  }

  function value(name: string): string {
    const el = form!.elements.namedItem(name) as
      | HTMLInputElement
      | HTMLTextAreaElement
      | HTMLSelectElement
      | null;
    return (el?.value || "").trim();
  }

  form.addEventListener("submit", (e) => {
    e.preventDefault();

    // Honeypot tripped: pretend success, drop silently.
    if (honeypot && honeypot.value.trim() !== "") {
      setStatus("Thanks. We'll be in touch.", "ok");
      form.reset();
      return;
    }

    const email = value("email");
    const org = value("org");
    const scope = value("scope");
    const budget = value("budget");
    const timeline = value("timeline");

    const missing = !email
      ? "your email"
      : !org
        ? "your company or project"
        : !scope
          ? "what you need built"
          : !budget
            ? "a budget range"
            : "";

    if (missing) {
      setStatus(`Please add ${missing}.`, "err");
      (form.elements.namedItem(
        !email ? "email" : !org ? "org" : !scope ? "scope" : "budget",
      ) as HTMLElement | null)?.focus();
      return;
    }

    const subject = `Engagement enquiry — ${org}`;
    const body = [
      `From:     ${email}`,
      `Company:  ${org}`,
      `Budget:   ${budget}`,
      `Timeline: ${timeline || "not stated"}`,
      "",
      "What we need:",
      scope,
    ].join("\n");

    const mailto =
      `mailto:${HIRE_TO}` +
      `?subject=${encodeURIComponent(subject)}` +
      `&body=${encodeURIComponent(body)}`;

    setStatus(
      `Opening your email client. If nothing happens, send the same to ${HIRE_TO}.`,
      "ok",
    );
    window.location.href = mailto;
  });
}

ready(() => {
  initHire();
});
